<template>
  <div class="breast-implants-chart graphic-container" :class="{ 'graphic-container--social-mode': this.socialMode }">
    <h3 class="chart-hed" v-if="showHeading">
      Half of Norwegian suspect device investigations were inconclusive
    </h3>
    <p v-if="showDeck">
      A rare disclosure of malfunction and injury reports from one Norwegian regulator shows final conclusions of investigations into each incident.
    </p>
    <stacked-column-chart
      :chart-height-ratio="baseHeightRatio"
      :chart-data="data"
      :chart-options="options"></stacked-column-chart>
    <p class="chart-source">
      Incident reports obtained by Aftenposten journalists from the Norwegian <a href="https://www.dsb.no/menyartikler/om-dsb/about-dsb/" target="_blank">Directorate for Civil Protection (DSB)</a>
    </p>
  </div>
</template>

<script>
  import * as d3 from 'd3'
  import data from '../assets/norwegian-reports.json'
  import StackedColumnChart from '@/components/StackedColumnChart.vue'
  import embeddable from '../mixins/embeddable'

  export default {
    name: 'BreastImplantsChart',
    mixins: [embeddable],
    components: {
      StackedColumnChart,
    },
    data() {
      return {
        data,
        options: {
          barColors: ["#A83324", "#5c1c12", "#F8B700", "#3B98AB"],
          keys: [
            "analysis inconclusive",
            "analysis impossible",
            "malfunction",
            "no malfunction",
          ],
          labelWidth: "25",
          xAxisTickFormat: this.xAxisYearFormat,
          yAxisTickFormat: d => d === 0 ? d : d3.format(",.2r")(d),
          yAxisTicks: 5,
        }
      }
    }
  }
</script>
